"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checklist = void 0;
require("../../controls/Preview/Preview");
const ChecklistControls_1 = require("../../controls/Checklist/ChecklistControls");
const Utilities_1 = require("../Utilities");
const ProdSysBase_1 = require("./ProdSysBase");
class Checklist extends ProdSysBase_1.ProdSysBase {
    static Open(instance) {
        let instId = instance.id.valueAsString;
        let callback = function (instId, typeId, config) {
            let openDesigner = false;
            if (config) {
                $.each(config.split("|"), (idx, value) => {
                    if (parseInt(value) === typeId)
                        openDesigner = true;
                });
            }
            if (openDesigner) {
                let markup = require("../../templates/checklist_designer.tmpl.html");
                // Create Window
                let windowData = Utilities_1.synUtil.popupWindow({
                    title: "Checklist",
                    actions: ["Maximize", "Close"],
                    width: 1024,
                    height: 768,
                    minheight: 300,
                    minwidth: 400,
                    resizable: true,
                    modal: true,
                    synDesktopAware: true,
                    preventCloseOnEscpae: true,
                });
                $("#" + windowData.windowID).data("kendoWindow").maximize();
                // Initialize contents
                let configData = {
                    synUtil: Utilities_1.synUtil,
                    windowID: "popup_" + windowData.guid,
                    designerlLayout: "designerllayout" + windowData.guid,
                    designerTemplateColumn: "designertemplatecolumn" + windowData.guid,
                    designerControlColumn: "designercontrolcolumn" + windowData.guid,
                    designerChecklistPropertiesColumn: "designergeneralpropertiescolumn" + windowData.guid,
                    designerFieldPropertiesColumn: "designerpropertiescolumn" + windowData.guid,
                    saveButtonId: "saveButton_" + windowData.guid,
                    savecloseButtonId: "savecloseButton_" + windowData.guid,
                    cancelButtonId: "cancelButton_" + windowData.guid,
                    designerPropertySplitter: "designerpropertysplitter_" + windowData.guid,
                };
                // Create HTML from template
                let template = kendo.template(markup);
                windowData.contentDiv.html(template(configData));
                configData["loadingDiv"] = $("<div class='k-loading-image'></div>").appendTo($("#" + configData.designerlLayout));
                let checklistInstanceUrl = Utilities_1.synUtil.getWSUrl("ChecklistGetInstance");
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: checklistInstanceUrl,
                    requestData: JSON.stringify({ id: instId, checkout: true, fordesigner: true }),
                    done(instance) {
                        let checklistPane = $("#" + configData.designerlLayout);
                        checklistPane.synChecklist();
                        let saveInstance = function (close, buttonId) {
                            checklistPane.synChecklist("save", buttonId, close, instId, configData);
                        };
                        let isClosing = false;
                        $("#" + configData.designerlLayout).on("clsave", function () { saveInstance(false, undefined); });
                        $("#" + configData.saveButtonId).on("click", function () { saveInstance(false, "#" + configData.saveButtonId); });
                        $("#" + configData.savecloseButtonId).on("click", function () { saveInstance(true, "#" + configData.savecloseButtonId); });
                        $("#" + configData.cancelButtonId).on("click", function () {
                            $("#" + configData.windowID).data("kendoWindow").close();
                        });
                        $("#" + configData.windowID).data("kendoWindow").bind("close", function (e) {
                            if (!isClosing) {
                                e.preventDefault();
                                let closeCallback = function (close) {
                                    if (close) {
                                        isClosing = true;
                                        $("#" + configData.windowID).data("kendoWindow").close();
                                        Checklist.RefreshPreview();
                                    }
                                };
                                checklistPane.synChecklist("close", instId, closeCallback);
                            }
                        });
                        let sourceTypeId = parseInt(instId.split("|")[2], 10);
                        let mode = ChecklistControls_1.ChecklistMode.Designer;
                        if (sourceTypeId === 999999930)
                            mode |= ChecklistControls_1.ChecklistMode.Questionnaire;
                        let calledFromFatCient = false;
                        if (typeof window.synDesktopApp)
                            calledFromFatCient = true;
                        checklistPane.synChecklist("showDesigner", configData, instance, mode, $("#" + windowData.windowID), calledFromFatCient);
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url, false);
                        if (window.synDesktopApp == undefined)
                            $("#" + configData.windowID).data("kendoWindow").close();
                    }
                });
            }
            else
                Checklist.OpenClEditor(instId, false);
        };
        let typeId = instance.items["cgdocument.typeid"].valueToNumber(1);
        callback(instId, typeId, Utilities_1.synUtil.Configs.getValue("opencldesigner", undefined));
        return new ProdSysBase_1.ActionResult(true, instId);
    }
    static View(instance) {
        let instId = instance.id.valueAsString + "|" + instance.items["cgdocument.version"].valueToString();
        Checklist.OpenClEditor(instId, true);
        return new ProdSysBase_1.ActionResult(true, instId);
    }
    static OpenClEditor(instId, readOnly) {
        let markup;
        if (readOnly)
            markup = require("../../templates/checklist_readonly.tmpl.html");
        else
            markup = require("../../templates/checklist.tmpl.html");
        // Create Window
        let windowOptions = {
            title: "Checklist",
            actions: ["Maximize", "Close"],
            width: 1024,
            height: 768,
            minheight: 300,
            minwidth: 400,
            resizable: true,
            modal: true,
            synDesktopAware: true,
        };
        if (!readOnly)
            windowOptions["preventCloseOnEscpae"] = true;
        let windowData = Utilities_1.synUtil.popupWindow(windowOptions);
        let saveInstance = function (close, buttonId) {
            let checklistPane = $("#" + editConfigData.checklistId);
            checklistPane.synChecklist("save", buttonId, close, instId, editConfigData);
        };
        window.onkeydown = function (e) {
            if (e.ctrlKey && e.keyCode === 83) { // save
                event.stopPropagation();
                event.preventDefault();
                saveInstance(false, "#" + editConfigData["saveButtonId"]);
            }
        };
        // Initialize contents
        let editConfigData = {
            synUtil: Utilities_1.synUtil,
            windowID: "popup_" + windowData.guid,
            checklistId: "checklist_" + windowData.guid,
        };
        if (readOnly)
            editConfigData["okButtonId"] = "okButton_" + windowData.guid;
        else {
            editConfigData["saveButtonId"] = "saveButton_" + windowData.guid;
            editConfigData["savecloseButtonId"] = "savecloseButton_" + windowData.guid;
            editConfigData["cancelButtonId"] = "cancelButton_" + windowData.guid;
        }
        // Create HTML from template
        let template = kendo.template(markup);
        windowData.contentDiv.html(template(editConfigData));
        editConfigData["loadingDiv"] = $("<div class='k-loading-image'></div>").appendTo($("#" + editConfigData.checklistId));
        let checklistInstanceUrl = Utilities_1.synUtil.getWSUrl("ChecklistGetInstance");
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: checklistInstanceUrl,
            requestData: JSON.stringify({ id: instId, checkout: !readOnly, fordesigner: false, view: readOnly }),
            done(instance) {
                let checklistPane = $("#" + editConfigData.checklistId);
                checklistPane.synChecklist();
                let isClosing = false;
                $("#" + editConfigData["saveButtonId"]).on("click", function () { saveInstance(false, "#" + editConfigData["saveButtonId"]); });
                $("#" + editConfigData["savecloseButtonId"]).on("click", function () { saveInstance(true, "#" + editConfigData["savecloseButtonId"]); });
                $("#" + editConfigData["cancelButtonId"]).on("click", function () {
                    $("#" + editConfigData.windowID).data("kendoWindow").close();
                });
                $("#" + editConfigData["okButtonId"]).on("click", function () {
                    if (window.synDesktopApp != undefined)
                        window.synDesktopApp.endDialog("1");
                    else
                        $("#" + editConfigData.windowID).data("kendoWindow").close();
                });
                $("#" + editConfigData.windowID).data("kendoWindow").bind("close", function (e) {
                    if (!isClosing) {
                        e.preventDefault();
                        let closeCallback = function (close) {
                            if (close) {
                                isClosing = true;
                                $("#" + editConfigData.windowID).data("kendoWindow").close();
                                if (!readOnly)
                                    Checklist.RefreshPreview();
                            }
                        };
                        if (readOnly)
                            closeCallback(true);
                        else {
                            let checklistPane = $("#" + editConfigData.checklistId);
                            checklistPane.synChecklist("close", instId, closeCallback);
                        }
                    }
                });
                checklistPane.synChecklist("setInstance", instance, editConfigData, ChecklistControls_1.ChecklistMode.Editor, readOnly);
            },
            fail(jqXHR, textStatus, errorThrown, url) {
                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url, false);
                if (window.synDesktopApp == undefined)
                    $("#" + editConfigData.windowID).data("kendoWindow").close();
            }
        });
    }
}
exports.Checklist = Checklist;
Checklist.RefreshPreview = function () {
    // Refresh Preview if exists
    let preview = $("#contentPane").find("#Preview");
    if (preview && preview.data("synPreview"))
        preview.synPreview("recreateAsync");
};
